import React, { useEffect } from "react"

export interface IJuicerFeedBladeProps {
    className?: string;
    juicerId: string;
}

export const JuicerFeedBlade: React.FC<IJuicerFeedBladeProps> = ({
    className = "",
    juicerId
}) => {

    useEffect(() => {

        const linkTag = document.createElement("link")
        linkTag.href = "https://assets.juicer.io/embed.css"
        linkTag.rel = "stylesheet"
        linkTag.media = "all"
        linkTag.type = "text/css"
        document.head.appendChild(linkTag)

        const script = document.createElement("script")
        script.src = "https://assets.juicer.io/embed.js"
        script.async = true
        script.integrity =
            "sha384-XAi27DYg8ZWX0Q5xZ9Y9/rvHbe4N9r8FcHLFG63D29I44X1GxCGR5c0qbG5HeyFv"
        script.crossOrigin = "anonymous"
        document.body.appendChild(script)

        return () => {
            // clean up the script when the component in unmounted
            document.body.removeChild(script)
            document.head.removeChild(linkTag)
        }
    }, [])

    return (
        <div className={`w-full ${className}`}>
            <ul className="list-none juicer-feed" data-feed-id={juicerId}></ul>
        </div>
    )
}

export default JuicerFeedBlade;